import RichTextEditor from '@shared/components/rich-text-editor/rich-text-editor';
import { Controller, useFormContext } from 'react-hook-form';
import { type SecrFormValues } from '../schema';

export function ActionsTakenEditor() {
  const { control } = useFormContext<SecrFormValues>();
  return (
    <Controller
      control={control}
      name="actionsTaken"
      render={({ field }) => (
        <RichTextEditor
          value={field.value ?? ''}
          onChange={field.onChange}
          placeholder="Describe the steps your organisation has taken to improve energy efficiency..."
          namespace="secr-actions-taken"
        />
      )}
    />
  );
}
